function index() {
  return import(/* webpackChunkName: "page-index" */ '@/app/pages/index.vue')
}
function callback() {
  return import(
    /* webpackChunkName: "page-callback" */ '@/app/pages/callback.vue'
  )
}
function logout() {
  return import(/* webpackChunkName: "page-logout" */ '@/app/pages/logout.vue')
}
function page_not_found() {
  return import(
    /* webpackChunkName: "page-page-not-found" */ '@/app/pages/page-not-found.vue'
  )
}
function change_password_index() {
  return import(
    /* webpackChunkName: "page-change_password-index" */ '@/app/pages/change_password/index.vue'
  )
}
function contracts_index() {
  return import(
    /* webpackChunkName: "page-contracts-index" */ '@/app/pages/contracts/index.vue'
  )
}
function refunds_operation_index() {
  return import(
    /* webpackChunkName: "page-refunds_operation-index" */ '@/app/pages/refunds_operation/index.vue'
  )
}
function contracts__dataorigin__tenantid__number__id() {
  return import(
    /* webpackChunkName: "page-contracts-dataorigin-tenantid-number-id" */ '@/app/pages/contracts/_dataorigin/_tenantid/_number/_id.vue'
  )
}

export default [
  {
    name: 'index',
    path: '',
    component: index,
  },
  {
    name: 'callback',
    path: 'callback',
    component: callback,
    meta: {
      isPublic: true,
      isOidcCallback: true,
    },
  },
  {
    name: 'logout',
    path: 'logout',
    component: logout,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'page-not-found',
    path: 'page-not-found',
    component: page_not_found,
    meta: {
      isPublic: true,
    },
  },
  {
    name: 'change_password',
    path: 'change_password',
    component: change_password_index,
  },
  {
    name: 'contracts',
    path: 'contracts',
    component: contracts_index,
  },
  {
    name: 'refunds_operation',
    path: 'refunds_operation',
    component: refunds_operation_index,
  },
  {
    name: 'contracts-dataorigin-tenantid-number-id',
    path: 'contracts/:dataorigin/:tenantid/:number/:id?',
    component: contracts__dataorigin__tenantid__number__id,
  },
]
